/**
 * modalAnimations — zentrale Keyframes + Animation-Strings für die
 * Duplicate/Contact-Modals.
 *
 * Warum eine Datei: alle Duplikat-relevanten Modals (Action, Merge, Detail,
 * InlineHint) sollen sich konsistent anfühlen. Statt in jedem File eigene
 * Keyframes zu injecten (Copy-Paste, drift-anfällig), gibt es hier einen
 * einzelnen idempotenten Injector.
 *
 * Verwendung:
 *   import { modalOverlayAnim, modalCardAnim, sectionAnim } from './modalAnimations';
 *   ...
 *   overlay: { ..., animation: modalOverlayAnim }
 *   modal:   { ..., animation: modalCardAnim }
 *   section: { ..., animation: sectionAnim(80) }  // per-index Stagger
 */

const CSS_ID = 'bc-modal-anim';

if (typeof document !== 'undefined' && !document.getElementById(CSS_ID)) {
  const s = document.createElement('style');
  s.id = CSS_ID;
  s.textContent = `
    @keyframes bcModalOverlayIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes bcModalCardIn {
      0%   { opacity: 0; transform: translateY(22px) scale(0.94); }
      55%  { opacity: 1; }
      100% { opacity: 1; transform: translateY(0) scale(1); }
    }
    @keyframes bcSectionIn {
      from { opacity: 0; transform: translateY(6px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes bcHintIn {
      from { opacity: 0; transform: translateY(10px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    /* Respektiere Betriebssystem-Setting "Bewegung reduzieren" — Motion-
       sensitive User bekommen einen instant-Fade statt Scale/Slide. */
    @media (prefers-reduced-motion: reduce) {
      @keyframes bcModalOverlayIn { from { opacity: 0; } to { opacity: 1; } }
      @keyframes bcModalCardIn    { from { opacity: 0; } to { opacity: 1; } }
      @keyframes bcSectionIn      { from { opacity: 0; } to { opacity: 1; } }
      @keyframes bcHintIn         { from { opacity: 0; } to { opacity: 1; } }
    }
  `;
  document.head.appendChild(s);
}

export const modalOverlayAnim = 'bcModalOverlayIn 420ms cubic-bezier(0.32, 0.72, 0, 1) both';
export const modalCardAnim = 'bcModalCardIn 420ms cubic-bezier(0.16, 1, 0.3, 1)';
export const hintAnim = 'bcHintIn 220ms cubic-bezier(0.16, 1, 0.3, 1)';
export const sectionAnim = (delayMs = 0) =>
  `bcSectionIn 380ms cubic-bezier(0.16, 1, 0.3, 1) ${delayMs}ms both`;
